import { ToastTypes, launchToast } from '../../../components'
import { useApi, useApiMutation } from '../../../utils'
import {
    GetEventMatchingPauseConfigQuerySchema,
    UpdateEventMatchingPauseConfigMutationSchema,
    UpdateEventMatchingPauseConfigVariablesSchema,
    type EventMatchingPauseConfig,
    type UpdateEventMatchingPauseConfigMutation,
    type UpdateEventMatchingPauseConfigVariables
} from '../matchingFlag_schemas'

export const useGetEventMatchingPauseConfigQuery = () => {
    const result = useApi('/platform/get_event_matching_pause_config', {}, GetEventMatchingPauseConfigQuerySchema, {
        queryKey: ['platform/get_event_matching_pause_config']
    })

    return {
        data: result.data,
        loading: result.isFetching,
        error: result.error,
        refetch: async () => {
            const next = await result.refetch()
            return { ...next, data: next.data }
        }
    }
}

interface UpdateEventMatchingPauseConfigOptions {
    onCompleted?: (data: UpdateEventMatchingPauseConfigMutation) => void
    onError?: (error: Error) => void
}

export const useUpdateEventMatchingPauseConfigMutation = (options?: UpdateEventMatchingPauseConfigOptions) => {
    const { mutateAsync, isPending, error } = useApiMutation<
        UpdateEventMatchingPauseConfigVariables,
        typeof UpdateEventMatchingPauseConfigMutationSchema
    >('/platform/update_event_matching_pause_config', UpdateEventMatchingPauseConfigMutationSchema, {
        onError: (err) => {
            if (options?.onError) options.onError(err)
            else launchToast(ToastTypes.Error, err.message || 'Failed to update configuration')
        }
    })

    const updatePauseConfig = async (config: EventMatchingPauseConfig) => {
        const variables = UpdateEventMatchingPauseConfigVariablesSchema.parse({
            event_matching_pause_config_json: config
        })
        const data = await mutateAsync(variables)
        if (data) options?.onCompleted?.(data)
        return data
    }

    return { updatePauseConfig, loading: isPending, error }
}
